import 'knockout.validation';
import ko from 'knockout';
import { LocaleUtils } from './locale-utils';

export class PhoneViewModel {
	private _phonePrefix = LocaleUtils.getDefaultPhonePrefix();
	private _enforcePrefix: boolean;
	public value = ko.observable<string>();

	public isValid = ko.pureComputed(() => {
		return (
			this.value() &&
			(!this._enforcePrefix || this.value()?.startsWith(this._phonePrefix)) &&
			this.value() !== this._phonePrefix
		);
	});

	constructor(enforcePrefix: boolean = true) {
		this._enforcePrefix = enforcePrefix;

		this.value(this._phonePrefix);

		// Subscribe to changes to ensure the prefix is always maintained if enforced
		this.value.subscribe((newValue) => {
			if (
				this._enforcePrefix &&
				newValue &&
				!newValue.startsWith(this._phonePrefix)
			) {
				this.value(this._phonePrefix);
			}
		});
	}
}
